/*
 * Шаги курса «Гитара с нуля» поверх MusicCore (music-core.js):
 *   guitar-tune    — настроить шесть струн (GuitarTunerCore.advise: не просит
 *                    «подтянуть» на октаву — урок #1788 тюнера);
 *   guitar-note    — сыграть ноту или рифф по ладам, курс слышит каждую ноту;
 *   guitar-chord   — взять аккорд, курс слышит, тот ли он и какой ноты нет;
 *   guitar-strings — проверить аккорд по одной струне (где глушится);
 *   guitar-switch  — менять аккорды по тактам под метроном;
 *   guitar-strum   — бой по схеме под метроном: время каждого удара;
 *                    без микрофона — касанием;
 *   guitar-play    — свободная игра по гамме: доля нот из гаммы.
 * Каждый шаг работает и без микрофона: понятная фраза и «Пропустить»
 * (api.skip — не ошибка), у ритма — касание вместо гитары.
 * Пороги — MusicCore.LIMITS, замер — docs/why/guitar-course.md.
 */
(function () {
    'use strict';
    var K = window.CourseKit, MC = window.MusicCore;
    if (!K || !MC) return;
    MC.install(K);
    var PC = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

    function T(step) { return step.t || {}; }

    /* ── общий блок «микрофон» ──────────────────────────────────────── */

    /*
     * Кнопка «Включить микрофон», уровень, строка состояния. onReady(listener)
     * зовётся, когда звук пошёл. Отказ — фраза причины и «Пропустить».
     * opts.alt = {label, fn} — запасной путь без микрофона (касание).
     */
    function micPanel(host, api, onReady, opts) {
        opts = opts || {};
        var box = api.el('div', 'gt-mic');
        var meter = api.el('div', 'gt-meter');
        var bar = api.el('span');
        meter.appendChild(bar);
        var status = api.el('p', 'gt-status');
        status.setAttribute('aria-live', 'polite');
        status.textContent = api.tt('g_mic_hint');
        box.appendChild(meter);
        box.appendChild(status);
        host.appendChild(box);
        var raf = 0, L = null;
        function loop() {
            if (!api.alive() || !L) return;
            var v = L.level();
            var db = 20 * Math.log10(v + 1e-9);
            bar.style.width = Math.max(0, Math.min(100, (db + 60) / 50 * 100)) + '%';
            raf = requestAnimationFrame(loop);
        }
        api.onCleanup(function () { if (raf) cancelAnimationFrame(raf); });
        function start() {
            api.primary(api.tt('g_mic_start'), null);
            status.textContent = api.tt('g_listening');
            MC.listen(api).then(function (listener) {
                if (!api.alive()) { listener.stop(); return; }
                L = listener;
                box.classList.add('is-on');
                raf = requestAnimationFrame(loop);
                onReady(listener, status);
            }, function (err) {
                if (!api.alive()) return;
                status.textContent = api.micError(err);
                box.classList.add('is-off');
                if (opts.alt) {
                    api.primary(opts.alt.label, opts.alt.fn);
                } else {
                    api.primary(api.tt('g_mic_retry'), start);
                }
                api.secondary(api.tt('g_no_mic_skip'), function () { api.skip(api.tt('g_skipped_note')); });
            });
        }
        api.primary(api.tt('g_mic_start'), start);
        api.secondary(opts.alt ? opts.alt.label : api.tt('g_no_mic_skip'), opts.alt ? opts.alt.fn : function () { api.skip(api.tt('g_skipped_note')); });
        return {
            status: status,
            setStatus: function (s, cls) { status.textContent = s; status.className = 'gt-status' + (cls ? ' ' + cls : ''); }
        };
    }

    function refButton(host, api, label, play) {
        var b = api.el('button', 'lg-btn lg-btn-ghost lg-btn-sm', '▶ ' + label);
        b.type = 'button';
        b.addEventListener('click', function () {
            b.disabled = true;
            api.audioCtx().then(function (ctx) { return play(ctx); }).catch(function () {}).then(function () { b.disabled = false; });
        });
        var row = api.el('div', 'crs-acts');
        row.appendChild(b);
        host.appendChild(row);
        return b;
    }

    function stringsWithPc(c, pc) {
        var out = [];
        if (!c.strings) return out;
        c.strings.forEach(function (m, i) { if (m != null && m % 12 === pc) out.push(6 - i); });
        return out;
    }

    /* ── настройка ──────────────────────────────────────────────────── */

    K.step('guitar-tune', {
        reviewable: false,
        mount: function (host, step, api) {
            var t = T(step);
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            var G = window.GuitarTunerCore;
            var strs = G.strings('standard');            // от 6-й к 1-й
            var row = api.el('div', 'gt-strings');
            var cards = {}, done = {}, cur = 6;
            strs.forEach(function (s) {
                var b = api.el('button', 'gt-string');
                b.type = 'button';
                b.innerHTML = '<b>' + s.num + '</b><span>' + s.name + s.oct + '</span>';
                b.setAttribute('aria-label', api.tt('g_string_n', { n: s.num }) + ' ' + s.name + s.oct);
                b.addEventListener('click', function () { select(s.num); });
                cards[s.num] = b;
                row.appendChild(b);
            });
            host.appendChild(row);
            var gauge = api.el('div', 'gt-gauge');
            var needle = api.el('i');
            gauge.appendChild(needle);
            gauge.appendChild(api.el('span', 'gt-gauge-mid'));
            var readout = api.el('p', 'gt-readout', '—');
            host.appendChild(gauge);
            host.appendChild(readout);
            refButton(host, api, api.tt('g_ref_string'), function (ctx) { return MC.play(ctx, [strs[6 - cur].midi], {}); });
            function select(n) {
                cur = n;
                Object.keys(cards).forEach(function (k) { cards[k].classList.toggle('is-cur', +k === n); });
                readout.textContent = api.tt('g_tune_pick', { n: n, note: strs[6 - n].name + strs[6 - n].oct });
            }
            select(6);
            var okSince = 0;
            var panel = micPanel(host, api, function (L) {
                MC.pitchStream(L, function (r, tMs, a) {
                    if (!r) return;
                    var adv = G.advise(r.freq, strs, { locked: cur });
                    var c = Math.max(-50, Math.min(50, adv.cents));
                    needle.style.left = (50 + c) + '%';
                    gauge.classList.toggle('is-ok', adv.kind === 'ok');
                    var msg;
                    if (adv.kind === 'ok') msg = api.tt('g_tune_ok');
                    else if (adv.kind === 'tighten') msg = api.tt('g_tune_tighten', { c: Math.abs(adv.cents) });
                    else if (adv.kind === 'loosen') msg = api.tt('g_tune_loosen', { c: Math.abs(adv.cents) });
                    else if (adv.kind === 'other') msg = api.tt('g_tune_other', { n: adv.other.num });
                    else msg = api.tt('g_tune_far');
                    readout.textContent = r.note + ' · ' + msg;
                    if (adv.kind === 'ok') {
                        if (!okSince) okSince = tMs;
                        if (tMs - okSince >= 700 && !done[cur]) {
                            done[cur] = true;
                            cards[cur].classList.add('is-done');
                            api.announce(api.tt('g_tune_ok') + ' ' + cur);
                            okSince = 0;
                            var left = strs.filter(function (s) { return !done[s.num]; });
                            if (!left.length) {
                                panel.setStatus(api.tt('g_tune_all'), 'is-good');
                                api.answer({ correct: true, explain: t.explain || null });
                                return;
                            }
                            select(left[0].num);
                        }
                    } else okSince = 0;
                });
                panel.setStatus(api.tt('g_tune_start'));
            });
        }
    });

    /* ── нота и рифф ────────────────────────────────────────────────── */

    /* data: notes [{s, f}] — по порядку; все сразу на одном рисунке. */
    K.step('guitar-note', {
        reviewable: false,
        mount: function (host, step, api) {
            var t = T(step);
            var notes = step.notes || [{ s: step.s, f: step.f }];
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            var figBox = api.el('div', 'crs-fig');
            host.appendChild(figBox);
            var tabRow = api.el('div', 'gt-seq');
            host.appendChild(tabRow);
            var cells = notes.map(function (n, i) {
                var midi = MC.stringMidi(n.s) + n.f;
                var c = api.el('span', 'gt-seq-c');
                c.innerHTML = '<b>' + MC.noteName(midi) + '</b><small>' + api.tt('g_sf', { s: n.s, f: n.f }) + '</small>';
                tabRow.appendChild(c);
                return { el: c, midi: midi, n: n };
            });
            var i = 0, misses = 0, counted = {};
            function draw() {
                var fromF = Math.max(0, Math.min.apply(null, notes.map(function (n) { return n.f || 99; })) - 1);
                var dots = [], seen = {};
                notes.forEach(function (n, k) {
                    var key = n.s + ':' + n.f;
                    if (seen[key]) return;
                    seen[key] = 1;
                    dots.push({ s: n.s, f: n.f, root: k === i, label: String(notes.indexOf(n) + 1) });
                });
                figBox.innerHTML = MC.fretboardSvg({ notes: dots, from: fromF === 99 ? 0 : fromF, frets: Math.max(5, Math.max.apply(null, notes.map(function (n) { return n.f; })) - fromF + 1) });
                cells.forEach(function (c, k) { c.el.classList.toggle('is-cur', k === i); });
            }
            draw();
            refButton(host, api, api.tt('g_ref_notes'), function (ctx) { return MC.play(ctx, cells.map(function (c) { return c.midi; }), { bpm: step.bpm || 80 }); });
            var heldSince = 0, wrongSince = 0, wrongMidi = null;
            var panel = micPanel(host, api, function (L) {
                panel.setStatus(api.tt('g_note_play', { note: MC.noteName(cells[0].midi) }));
                MC.pitchStream(L, function (r, tMs) {
                    if (i >= cells.length) return;
                    var want = cells[i];
                    if (!r) { heldSince = 0; return; }
                    var dc = (r.midi - want.midi) * 100;
                    if (Math.abs(dc) <= MC.LIMITS.PITCH_OK_CENTS) {
                        wrongSince = 0;
                        if (!heldSince) heldSince = tMs;
                        if (tMs - heldSince >= MC.LIMITS.PITCH_HOLD_MS) {
                            want.el.classList.remove('is-cur');
                            want.el.classList.add('is-done');
                            i++;
                            heldSince = 0;
                            if (i >= cells.length) {
                                panel.setStatus(api.tt('g_note_all'), 'is-good');
                                api.answer({ correct: true, score: Math.max(0.5, 1 - misses * 0.1), explain: t.explain || null });
                                return;
                            }
                            draw();
                            panel.setStatus(api.tt('g_note_play', { note: MC.noteName(cells[i].midi) }));
                        }
                    } else {
                        heldSince = 0;
                        var m = Math.round(r.midi);
                        /* Только что сыгранная нота ещё звенит, пока человек
                           переходит к следующей, — это не ошибка. Промах — это
                           нота, которой в пройденной части фразы не было, и
                           каждая такая нота на цель считается один раз. */
                        var played = cells.slice(0, i).some(function (c) { return c.midi === m; });
                        if (played) { wrongMidi = null; return; }
                        if (m !== wrongMidi) { wrongMidi = m; wrongSince = tMs; }
                        if (tMs - wrongSince >= 450) {
                            var fret = m - MC.stringMidi(want.n.s);
                            var msg = fret >= 0 && fret <= 15
                                ? api.tt('g_note_wrong', { heard: MC.noteName(m), f: fret, need: want.n.f })
                                : api.tt('g_note_wrong_other', { heard: MC.noteName(m), s: want.n.s });
                            panel.setStatus(msg, 'is-bad');
                            var key = i + ':' + m;
                            if (!counted[key]) { counted[key] = 1; misses++; }
                            wrongSince = Infinity;
                        }
                    }
                });
            });
        }
    });

    /* ── аккорд ─────────────────────────────────────────────────────── */

    K.step('guitar-chord', {
        reviewable: false,
        mount: function (host, step, api) {
            var t = T(step);
            var c = MC.chord(step.chord);
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            api.figure(host, { kind: 'chord', chord: step.chord });
            refButton(host, api, api.tt('g_ref_chord'), function (ctx) { return MC.play(ctx, step.chord, {}); });
            var tips = t.tips || [];
            var run = 0, soundFor = 0, lastT = 0, finished = false, weakSeen = {};
            var panel = micPanel(host, api, function (L) {
                panel.setStatus(api.tt('g_chord_play', { chord: c.name }));
                var started = Date.now();
                MC.chromaStream(L, function (st) {
                    if (finished || !api.alive()) return;
                    var dt = lastT ? st.t - lastT : 0;
                    lastT = st.t;
                    if (!st.pooled || st.rms < MC.LIMITS.SILENT_RMS) { run = 0; return; }
                    soundFor += dt;
                    var v = MC.analysis.judgeChord(st.pooled, c, st.bass);
                    if (v.ok) {
                        run++;
                        v.weak.forEach(function (pc) { weakSeen[pc] = (weakSeen[pc] || 0) + 1; });
                        if (run >= MC.LIMITS.CHORD_HOLD_N) {
                            finished = true;
                            var weak = Object.keys(weakSeen).filter(function (pc) { return weakSeen[pc] >= run; }).map(Number);
                            var hint = weak.length ? api.tt('g_weak_tone', { note: weak.map(function (pc) { return PC[pc]; }).join(', '), strings: weak.map(function (pc) { return stringsWithPc(c, pc).map(function (n) { return api.tt('g_string_n', { n: n }); }).join(', '); }).join('; ') }) : null;
                            panel.setStatus(api.tt('g_chord_ok', { chord: c.name }), 'is-good');
                            api.answer({ correct: true, explain: [hint, t.explain].filter(Boolean).join('\n\n') || null });
                        }
                    } else {
                        run = 0;
                        if (soundFor > 1.2) panel.setStatus(v.heard ? api.tt('g_hear_chord', { chord: v.heard }) + ' — ' + api.tt('g_chord_check') : api.tt('g_chord_check'), 'is-bad');
                    }
                });
                var giveUp = setTimeout(function () {
                    if (finished || !api.alive()) return;
                    api.secondary(api.tt('g_give_up'), function () {
                        finished = true;
                        api.answer({ correct: false, reveal: c.name + ' — ' + (c.shape ? fretString(c.shape.frets) : ''), explain: tips.length ? tips.join('\n') : (t.explain || null) });
                    });
                }, 12000);
                api.onCleanup(function () { clearTimeout(giveUp); });
            });
        }
    });

    function fretString(frets) { return frets.map(function (f) { return f < 0 ? 'x' : String(f); }).join(''); }

    /* ── аккорд по струнам ──────────────────────────────────────────── */

    K.step('guitar-strings', {
        reviewable: false,
        mount: function (host, step, api) {
            var t = T(step);
            var c = MC.chord(step.chord);
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            api.figure(host, { kind: 'chord', chord: step.chord });
            var list = [];
            c.strings.forEach(function (m, i) { if (m != null) list.push({ num: 6 - i, midi: m }); });
            var row = api.el('div', 'gt-strings');
            list.forEach(function (s) {
                var b = api.el('span', 'gt-string');
                b.innerHTML = '<b>' + s.num + '</b><span>' + MC.noteName(s.midi) + '</span>';
                s.el = b;
                row.appendChild(b);
            });
            host.appendChild(row);
            var k = 0, clean = 0, bad = [], heldSince = 0, lastHeard = 0, waitFrom = 0, finished = false;
            function next(ok, note) {
                var s = list[k];
                s.el.classList.add(ok ? 'is-done' : 'is-bad');
                if (ok) clean++; else bad.push(note);
                k++;
                heldSince = 0;
                waitFrom = Date.now();
                if (k >= list.length) {
                    finished = true;
                    api.secondary(null, null);
                    api.answer({
                        correct: clean === list.length,
                        score: clean / list.length,
                        explain: [api.tt('g_strings_result', { ok: clean, total: list.length })].concat(bad).concat(clean === list.length ? [] : (t.tips || [])).join('\n')
                    });
                    return;
                }
                prompt();
            }
            var panel;
            function prompt() {
                list.forEach(function (s, j) { s.el.classList.toggle('is-cur', j === k); });
                panel.setStatus(api.tt('g_strings_pluck', { n: list[k].num, note: MC.noteName(list[k].midi) }));
                api.secondary(api.tt('g_strings_skip'), function () { next(false, api.tt('g_strings_muted', { n: list[k].num })); });
            }
            panel = micPanel(host, api, function (L) {
                prompt();
                waitFrom = Date.now();
                MC.pitchStream(L, function (r, tMs) {
                    if (finished) return;
                    var s = list[k];
                    if (!r) { heldSince = 0; return; }
                    var dc = (r.midi - s.midi) * 100;
                    if (Math.abs(dc) <= MC.LIMITS.PITCH_OK_CENTS) {
                        if (!heldSince) heldSince = tMs;
                        if (tMs - heldSince >= MC.LIMITS.PITCH_HOLD_MS) next(true);
                    } else {
                        heldSince = 0;
                        if (tMs - lastHeard > 500 && Date.now() - waitFrom > 900) {
                            lastHeard = tMs;
                            var m = Math.round(r.midi);
                            panel.setStatus(api.tt('g_strings_wrong', { n: s.num, heard: MC.noteName(m), note: MC.noteName(s.midi) }), 'is-bad');
                        }
                    }
                });
            });
        }
    });

    /* ── смена аккордов по тактам ───────────────────────────────────── */

    K.step('guitar-switch', {
        reviewable: false,
        mount: function (host, step, api) {
            var t = T(step);
            var names = step.chords || ['Am', 'E'];
            var bars = step.bars || names.length * 2;
            var beats = step.beats || 4;
            var bpm = step.bpm || 60;
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            api.figure(host, { kind: 'chord', chords: names.filter(function (n, i) { return names.indexOf(n) === i; }) });
            var lane = api.el('div', 'gt-bars');
            var cells = [];
            for (var b = 0; b < bars; b++) {
                var name = names[b % names.length];
                var cl = api.el('div', 'gt-bar');
                cl.innerHTML = '<b>' + MC.chord(name).name + '</b><span class="gt-beats">' + new Array(beats + 1).join('<i></i>') + '</span>';
                lane.appendChild(cl);
                cells.push({ el: cl, name: name });
            }
            host.appendChild(lane);
            host.appendChild(api.el('p', 'crs-hint', api.tt('g_headphones')));
            var frames = [], metro = null, finished = false;
            api.onCleanup(function () { if (metro) metro.stop(); });
            var panel = micPanel(host, api, function (L) {
                panel.setStatus(api.tt('g_ready_bpm', { bpm: bpm }));
                api.primary(api.tt('g_start_ex'), function () { go(L); });
            });
            function go(L) {
                api.primary(null, null);
                frames = [];
                cells.forEach(function (c) { c.el.className = 'gt-bar'; });
                var lag = MC.latency.get(api, L.ctx).s;
                metro = MC.metronome(L.ctx, { bpm: bpm, beats: beats, countIn: beats, bars: bars });
                var unsub = MC.chromaStream(L, function (st) { frames.push(st.frame); });
                api.onCleanup(unsub);
                var t0 = metro.start();
                panel.setStatus(api.tt('g_count_in'));
                metro.onBeat(function (i) {
                    if (i < 0) { panel.setStatus(api.tt('g_count_in') + ' ' + (beats + i + 1)); return; }
                    var bar = Math.floor(i / beats), beat = i % beats;
                    cells.forEach(function (c, j) {
                        c.el.classList.toggle('is-cur', j === bar);
                        var dots = c.el.querySelectorAll('.gt-beats i');
                        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', j === bar && d <= beat);
                    });
                    if (bar < bars) panel.setStatus(api.tt('g_switch_now', { chord: MC.chord(cells[bar].name).name, next: bar + 1 < bars ? MC.chord(cells[bar + 1].name).name : '—' }));
                    if (bar >= bars && !finished) finish(t0, lag, unsub);
                });
            }
            function finish(t0, lag, unsub) {
                finished = true;
                unsub();
                if (metro) metro.stop();
                var spb = 60 / bpm, ok = 0, lines = [];
                cells.forEach(function (c, b) {
                    var from = t0 + lag + (b * beats + 1) * spb, to = t0 + lag + (b + 1) * beats * spb;
                    var win = frames.filter(function (f) { return f.t >= from + 0.4 && f.t <= to && f.c; });
                    var v = win.length >= 3 ? MC.judgeFrames(win, MC.chord(c.name)) : { ok: false, heard: null };
                    c.el.classList.remove('is-cur');
                    c.el.classList.add(v.ok ? 'is-done' : 'is-bad');
                    if (v.ok) ok++;
                    else lines.push(api.tt('g_switch_bad', { n: b + 1, chord: MC.chord(c.name).name, heard: v.heard || '—' }));
                });
                var score = ok / bars;
                api.answer({ correct: score >= 0.75, score: score, explain: [api.tt('g_switch_result', { ok: ok, total: bars })].concat(lines).concat(score < 0.75 ? (t.tips || []) : []).join('\n') });
            }
        }
    });

    /* ── бой по схеме ───────────────────────────────────────────────── */

    /* data: pattern «D.DUDUDU» (восьмые), bpm, bars, chord. */
    K.step('guitar-strum', {
        reviewable: false,
        mount: function (host, step, api) {
            var t = T(step);
            var pattern = step.pattern || 'D.D.D.D.';
            var bpm = step.bpm || 70, bars = step.bars || 2;
            var per = pattern.length;                    // ячеек на такт
            var beatsPerBar = step.beats || 4;
            var cellDur = beatsPerBar * 60 / bpm / per;
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            if (step.chord) api.figure(host, { kind: 'chord', chord: step.chord });
            var patBox = api.el('div', 'crs-fig');
            patBox.innerHTML = MC.patternHtml(pattern, countWords(api, per));
            host.appendChild(patBox);
            var lane = api.el('div', 'gt-lane');
            host.appendChild(lane);
            var mode = null, metro = null, finished = false, taps = [], onsets = [];
            api.onCleanup(function () { if (metro) metro.stop(); });
            var panel = micPanel(host, api, function (L) {
                mode = { kind: 'mic', L: L };
                var lat = MC.latency.get(api, L.ctx);
                if (!lat.measured) { calibrate(L); return; }
                ready();
            }, { alt: { label: api.tt('g_tap_mode'), fn: tapMode } });

            function ready() {
                panel.setStatus(api.tt('g_ready_bpm', { bpm: bpm }));
                api.secondary(null, null);
                api.primary(api.tt('g_start_ex'), go);
            }
            function tapMode() {
                api.audioCtx().then(function (ctx) {
                    if (!api.alive()) return;
                    mode = { kind: 'tap', ctx: ctx };
                    var pad = api.el('button', 'gt-pad', api.tt('g_tap_pad'));
                    pad.type = 'button';
                    pad.addEventListener('pointerdown', function (e) { e.preventDefault(); tap(e.timeStamp); });
                    api.onKey(function (k, e) { if (k === ' ' || k === 'space') { tap(e.timeStamp); return true; } return false; });
                    host.appendChild(pad);
                    panel.setStatus(api.tt('g_tap_ready'));
                    ready();
                });
            }
            function tap(ts) {
                if (!metro || finished || !mode || mode.kind !== 'tap') return;
                var heard = window.AudibleClock ? window.AudibleClock.heardAtPerf(mode.ctx, ts) : mode.ctx.currentTime;
                taps.push(heard);
                flash();
            }
            function flash() {
                patBox.classList.remove('is-hit');
                void patBox.offsetWidth;
                patBox.classList.add('is-hit');
            }
            function calibrate(L) {
                panel.setStatus(api.tt('g_calib_body'));
                api.primary(api.tt('g_calib_start'), function () {
                    api.primary(null, null);
                    var m = MC.metronome(L.ctx, { bpm: 80, beats: 4, countIn: 4, bars: 2, accent: false });
                    var got = [];
                    var unsub = MC.onsetStream(L, function (tt) { got.push(tt); });
                    var t0 = m.start();
                    m.onBeat(function (i) {
                        if (i < 0) { panel.setStatus(api.tt('g_count_in') + ' ' + (4 + i + 1)); return; }
                        panel.setStatus(api.tt('g_calib_go', { n: i + 1 }));
                        if (i >= 8) {
                            unsub();
                            m.stop();
                            var offs = [];
                            for (var b = 0; b < 8; b++) {
                                var bt = t0 + b * 0.75, best = null;
                                got.forEach(function (x) { var d = x - bt; if (d > -0.15 && d < 0.5 && (best === null || Math.abs(d - 0.12) < Math.abs(best - 0.12))) best = d; });
                                if (best !== null) offs.push(best);
                            }
                            if (offs.length >= 5) {
                                offs.sort(function (a, b) { return a - b; });
                                var med = offs[offs.length >> 1];
                                MC.latency.set(api, med);
                                panel.setStatus(api.tt('g_calib_done', { ms: Math.round(med * 1000) }), 'is-good');
                                ready();
                            } else {
                                panel.setStatus(api.tt('g_calib_fail'), 'is-bad');
                                api.primary(api.tt('g_calib_start'), function () { calibrate(L); });
                                api.secondary(api.tt('g_tap_mode'), tapMode);
                            }
                        }
                    });
                });
            }
            function go() {
                api.primary(null, null);
                api.secondary(null, null);
                taps = []; onsets = [];
                lane.innerHTML = '';
                var ctx = mode.kind === 'mic' ? mode.L.ctx : mode.ctx;
                metro = MC.metronome(ctx, { bpm: bpm, beats: beatsPerBar, countIn: beatsPerBar, bars: bars });
                var unsub = null;
                if (mode.kind === 'mic') unsub = MC.onsetStream(mode.L, function (x) { onsets.push(x); flash(); });
                var t0 = metro.start();
                var cellsEls = patBox.querySelectorAll('.mc-pat-c');
                var raf = 0;
                function loopCursor() {
                    if (!api.alive() || finished) return;
                    var heard = ctx.currentTime - (window.AudibleClock ? window.AudibleClock.lagS(ctx) : 0);
                    var idx = Math.floor((heard - t0) / cellDur);
                    for (var q = 0; q < cellsEls.length; q++) cellsEls[q].classList.toggle('is-cur', idx >= 0 && idx % per === q);
                    raf = requestAnimationFrame(loopCursor);
                }
                raf = requestAnimationFrame(loopCursor);
                api.onCleanup(function () { cancelAnimationFrame(raf); });
                metro.onBeat(function (i) {
                    if (i < 0) { panel.setStatus(api.tt('g_count_in') + ' ' + (beatsPerBar + i + 1)); return; }
                    if (i < bars * beatsPerBar) panel.setStatus(api.tt('g_bar_n', { n: Math.floor(i / beatsPerBar) + 1, total: bars }));
                    if (i >= bars * beatsPerBar && !finished) {
                        finished = true;
                        if (unsub) unsub();
                        metro.stop();
                        cancelAnimationFrame(raf);
                        judge(t0);
                    }
                });
            }
            function judge(t0) {
                var expected = [];
                for (var b = 0; b < bars; b++) for (var c = 0; c < per; c++) if (pattern[c] !== '.') expected.push(t0 + (b * per + c) * cellDur);
                var heard;
                if (mode.kind === 'mic') {
                    var lag = MC.latency.get(api, mode.L.ctx).s;
                    heard = onsets.map(function (x) { return x - lag; });
                } else heard = taps.slice();
                var r = MC.analysis.judgeRhythm(expected, heard, step.tol || MC.LIMITS.RHYTHM_TOL_S);
                // полоса времени: ожидаемые метки и где был удар
                var span = expected.length ? expected[expected.length - 1] - expected[0] + cellDur : 1;
                r.marks.forEach(function (mk) {
                    var x = api.el('i', mk.hit ? 'is-hit' : 'is-miss');
                    x.style.left = ((mk.t - expected[0]) / span * 100) + '%';
                    lane.appendChild(x);
                    if (mk.hit) {
                        var y = api.el('b');
                        y.style.left = ((mk.t + mk.err - expected[0]) / span * 100) + '%';
                        lane.appendChild(y);
                    }
                });
                var lines = [api.tt('g_rhythm_result', { hits: r.hits, total: r.total })];
                if (r.hits >= 3) {
                    var ms = Math.round(Math.abs(r.mean) * 1000);
                    lines.push(ms < 25 ? api.tt('g_rhythm_even') : (r.mean < 0 ? api.tt('g_rhythm_early', { ms: ms }) : api.tt('g_rhythm_late', { ms: ms })));
                    lines.push(api.tt('g_rhythm_spread', { ms: Math.round(r.sd * 1000) }));
                }
                if (r.extras > 1) lines.push(api.tt('g_rhythm_extra', { n: r.extras }));
                var pass = step.pass || 0.75;
                api.answer({ correct: r.score >= pass, score: r.score, explain: lines.concat(r.score < pass ? (t.tips || []) : (t.explain ? [t.explain] : [])).join('\n') });
            }
        }
    });

    function countWords(api, per) {
        var w = api.tt('g_count');
        var arr = String(w).split(' ');
        if (per === 8 && arr.length === 8) return arr;
        if (per === 4) return ['1', '2', '3', '4'];
        if (per === 6) return ['1', '2', '3', '4', '5', '6'];
        return arr.length === per ? arr : null;
    }

    /* ── свободная игра по гамме ────────────────────────────────────── */

    /* data: scale {root: 'A', type: 'minor-pentatonic'|'major-pentatonic'|'blues'}, seconds, bpm, positions (рисунок). */
    var SCALES = { 'minor-pentatonic': [0, 3, 5, 7, 10], 'major-pentatonic': [0, 2, 4, 7, 9], 'blues': [0, 3, 5, 6, 7, 10], 'minor': [0, 2, 3, 5, 7, 8, 10], 'major': [0, 2, 4, 5, 7, 9, 11] };
    K.step('guitar-play', {
        reviewable: false,
        mount: function (host, step, api) {
            var t = T(step);
            var sc = step.scale || { root: 'A', type: 'minor-pentatonic' };
            var rootPc = PC.indexOf(sc.root);
            var set = {};
            (SCALES[sc.type] || SCALES['minor-pentatonic']).forEach(function (i) { set[(rootPc + i) % 12] = 1; });
            var secs = step.seconds || 45;
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            if (step.figure) api.figure(host);
            var stat = api.el('div', 'gt-play');
            var big = api.el('div', 'crs-big', '0');
            var share = api.el('p', 'gt-readout', '');
            stat.appendChild(big);
            stat.appendChild(share);
            host.appendChild(stat);
            var notes = 0, inScale = 0, lastMidi = null, lastAt = 0, metro = null, iv = null, finished = false;
            api.onCleanup(function () { if (metro) metro.stop(); if (iv) clearInterval(iv); });
            var panel = micPanel(host, api, function (L) {
                panel.setStatus(api.tt('g_play_ready', { s: secs }));
                api.primary(api.tt('g_start_ex'), function () {
                    api.primary(null, null);
                    if (step.bpm) { metro = MC.metronome(L.ctx, { bpm: step.bpm, beats: 4, countIn: 4, volume: 0.25 }); metro.start(); }
                    var end = Date.now() + secs * 1000;
                    iv = setInterval(function () {
                        var left = Math.max(0, Math.ceil((end - Date.now()) / 1000));
                        panel.setStatus(api.tt('g_play_left', { s: left }));
                        if (left <= 0 && !finished) done();
                    }, 250);
                    MC.pitchStream(L, function (r, tMs) {
                        if (finished || !r) return;
                        var m = Math.round(r.midi);
                        if (m === lastMidi && tMs - lastAt < 600) { lastAt = tMs; return; }
                        lastMidi = m; lastAt = tMs;
                        notes++;
                        if (set[((m % 12) + 12) % 12]) inScale++;
                        big.textContent = String(notes);
                        share.textContent = api.tt('g_play_share', { pct: Math.round(inScale / notes * 100) });
                    });
                });
            });
            function done() {
                finished = true;
                clearInterval(iv);
                if (metro) metro.stop();
                var pct = notes ? inScale / notes : 0;
                var ok = notes >= (step.minNotes || 12) && pct >= 0.7;
                api.answer({ correct: ok, score: Math.min(1, pct), explain: [api.tt('g_play_result', { n: notes, pct: Math.round(pct * 100) })].concat(ok ? (t.explain ? [t.explain] : []) : (t.tips || [])).join('\n') });
            }
        }
    });
})();
